/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_Proration_NoteInputs */



/**
* | output |
* | --- |
* | "Covers remaining days this billing period" |
*
* @param {Plan_Upgrade_Proration_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_proration_note = /** @type {((inputs?: Plan_Upgrade_Proration_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_Proration_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deckt die verbleibenden Tage dieses Abrechnungszeitraums ab")
	return /** @type {LocalizedString} */ ("Covers remaining days this billing period")
});